import { Box, Card, CardContent, Chip, Grid, Typography } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { MatchingProfileData } from '@uplift/api';
import { useTimezone } from '@uplift/contexts';
import { useL10n } from '@uplift/hooks';
import { useUserDisplayNameQuery } from '@uplift/queries';
import { CalendarDateService } from '@uplift/services';
import { Button } from '@uplift/ui-v2';

type ProviderCardProps = {
  provider: MatchingProfileData;
  onProfileSelect: (providerId: string, selectedProfileName: string) => void;
};

export const ProviderCard: React.VFC<ProviderCardProps> = ({ provider, onProfileSelect }) => {
  const l10n = useL10n();
  const timezone = useTimezone();

  const topSpecialties = provider.specialties.filter(s => s.isTop);
  const regularSpecialties = provider.specialties.filter(s => !s.isTop);

  const { data: userName } = useUserDisplayNameQuery(provider.user.id);

  const displayName = userName?.fullWithAffixes;

  const handleProfileSelect = () => {
    const providerFullName = `${userName?.first} ${userName?.last}`;

    onProfileSelect(provider.user.id, providerFullName);
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6">
          {displayName}
        </Typography>
        <Typography variant="body2">
          {l10n.psychiatry.nextAvailable} {CalendarDateService.date(provider.nextAvailableDate).tz(timezone).format('ddd., MMMM D')}
        </Typography>
        {provider.specialties?.length > 0 && (
          <Box mt={2}>
            <Grid container spacing={1}>
              {topSpecialties.map(s => (
                <Grid key={s.id}>
                  <Chip label={s.name} />
                </Grid>
              ))}
              {regularSpecialties.length > 0 && (
                <Grid>
                  <Chip label={`+${regularSpecialties.length} more`} />
                </Grid>
              )}
            </Grid>
          </Box>
        )}
        <Box display="flex" justifyContent="flex-end">
          <Button type="button" color="secondary" endIcon={<ArrowForward />} onClick={handleProfileSelect}>
            {l10n.psychiatry.viewProfile}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};
